import MatomoTracker from '@jonkoops/matomo-tracker';
function createInstance(params) {
    return new MatomoTracker(params);
}
export default createInstance;
//# sourceMappingURL=instance.js.map